import Loading from './Loading.jsx';

export {Loading}


// WEBPACK FOOTER //
// ./src/components/modules/loading/index.js